var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60001 4.3V24.1C7.60001 24.9752 7.94768 25.8146 8.56655 26.4335C9.18542 27.0523 10.0248 27.4 10.9 27.4H24.1C24.9752 27.4 25.8146 27.0523 26.4335 26.4335C27.0523 25.8146 27.4 24.9752 27.4 24.1V9.6493C27.4 9.20967 27.3121 8.77449 27.1415 8.3693C26.9709 7.96412 26.7211 7.5971 26.4067 7.2898L20.937 1.9405C20.3205 1.33769 19.4925 1.00011 18.6303 1H10.9C10.0248 1 9.18542 1.34768 8.56655 1.96655C7.94768 2.58542 7.60001 3.42479 7.60001 4.3V4.3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 27.4V30.7C20.8 31.5752 20.4523 32.4146 19.8335 33.0335C19.2146 33.6523 18.3752 34 17.5 34H4.3C3.42479 34 2.58542 33.6523 1.96655 33.0335C1.34768 32.4146 1 31.5752 1 30.7V12.55C1 11.6748 1.34768 10.8354 1.96655 10.2165C2.58542 9.59768 3.42479 9.25 4.3 9.25H7.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.9d33613ee667373a2578e9eabac5cb96.svg";
export { ForwardRef as ReactComponent };